import React, { Component } from 'react'
import '../styles/ClusterCreation.css'
import members from '../images/AEC.png'
// import crop from '../images/crop.png'
import marketing from '../images/marketing.png'
import ClusterProfile from './ClusterProfile'
// import CropAndAreaCommitment from './CropAndAreaCommitment'
// import CollectiveMarketing from './CollectiveMarketing'
import TargetCropSelectionList from './TargetCropSelectionList'
import TargetCropSelection from './TargetCropSelection'
import AgroEnterpriseTracking from './AgroEnterpriseTracking'
import PopupMenu from '../widgets/PopupMenu'

class ClusterCreation extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accountType: props.type,
			clusterId: props.id,
			disabled: (props.id != null)? false: true,
			isViewDetails: props.isViewDetails,
			clusterName: props.name
		}
		this.onMenuItemClick = this.onMenuItemClick.bind(this)
		this.onSignal = this.onSignal.bind(this)
		this.setContent = this.setContent.bind(this)
		this.eventHandler = this.eventHandler.bind(this)
	}

	componentDidMount() {
		this.setContent(sessionStorage.getItem("cluster-tabId"))
	}

	onSignal(from, obj) {
		this.props.onSignal(from, obj)
	}

	onMenuItemClick(v) {
		this.setState({activeItem: v})
	}

	eventHandler(e) {
		this.props.selectView(sessionStorage.getItem("cluster-curr-view"), this.state.clusterId, this.state.clusterName, "cch-target")
	}

	setContent(id, formId) {
		console.log('cluster creation setcontent', id, formId)
		switch(id) {
			case "cch-target":
				var content = <TargetCropSelectionList clusterId={this.state.clusterId}
					onAddClick={this.setContent}
					viewDetails={(id) => {this.setContent("cch-target-form", id)}} key="tcsl" />
				break
			case "cch-target-form":
				content = <TargetCropSelection clusterId={this.state.clusterId} handleFooterEvent={this.eventHandler}
					siteId={this.props.siteId} disabled={(formId == null)? false: true} key="tcs"
					targetCropId={formId} viewListView={(id) => {this.setContent("cch-target", id)}}  />
				break
			case "cch-tracking":
				content = <AgroEnterpriseTracking isViewDetails={this.state.isViewDetails}
					displayValues={!this.state.disabled} />
				break
			default:
				content = <ClusterProfile isViewDetails={this.state.isViewDetails}
					displayValues={!this.state.disabled} submit={() => {
						this.setState({disabled: false})
					}} />
		}
		this.setState({content: content})
	}

	render() {
		const view = <div id="cluster-creation">
			<Header onItemClick={(item) => {
				if(this.state.clusterId == null) {
					this.setContent(item)
					return
				}
				this.props.selectView(sessionStorage.getItem("cluster-curr-view"),
					this.state.clusterId, this.state.clusterName, item)
				sessionStorage.setItem("cluster-tabId", item)
			}} disabled={this.state.disabled} />
			<Body content={this.state.content} />
		</div>
		return(view)
	}
}

class Header extends Component
{
	constructor(props) {
		super(props)
		this.state = {disabled: props.disabled}
		this.onItemClick = this.onItemClick.bind(this)
		this.mouseEnter = this.mouseEnter.bind(this)
		this.mouseLeave = this.mouseLeave.bind(this)
		this.setBurgerMenuLabel = this.setBurgerMenuLabel.bind(this)
	}

	componentDidMount() {
		if(this.state.disabled) {
			this.setBurgerMenuLabel("cch-profile")
			return
		}
		const items = document.querySelectorAll('#list-menu > div')
		for(const f of items) {
			f.style.color = "#000"
		}
		const imgs = document.querySelectorAll('#list-menu > div > img')
		for(const f of imgs) {
			f.style.opacity = "1.0"
		}
		const tabId = sessionStorage.getItem("cluster-tabId")
		switch(tabId) {
			case "cch-target":
			// case "cch-crop":
			// case "cch-volume":
			case "cch-tracking":
			case "cch-target-bm":
			// case "cch-crop-bm":
			// case "cch-volume-bm":
			case "cch-tracking-bm":
				var elem = document.getElementById(tabId)
				elem.style.background = "#e2e2e2"
				break
			default:
				elem = document.getElementById("cch-profile")
				elem.style.background = "#e2e2e2"
		}
		this.setBurgerMenuLabel(tabId)
	}

	componentDidUpdate(prevProps) {
		if(this.props.disabled != prevProps.disabled) {
			this.setState({disabled: this.props.disabled})
			if(this.props.disabled) {
				return
			}
			const items = document.querySelectorAll('#list-menu > div')
			for(const f of items) {
				f.style.color = "#000"
			}
			const imgs = document.querySelectorAll('#list-menu > div > img')
			for(const f of imgs) {
				f.style.opacity = "1.0"
			}
		}
	}

	onItemClick(e) {
		if(this.state.disabled) {
			return
		}
		const items = document.querySelectorAll('#list-menu > div')
		for(const f of items) {
			f.style.background = "#ffffff"
		}
		e.target.style.background = "#e2e2e2"
		this.props.onItemClick(e.target.id)
		this.setBurgerMenuLabel(e.target.id)
	}

	mouseEnter(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#e2e2e280"
	}

	mouseLeave(e) {
		if(this.state.disabled) {
			return
		}
		if(e.target.style.background === "rgb(226, 226, 226)") {
			return
		}
		e.target.style.background = "#ffffff"
	}

	setBurgerMenuLabel(id) {
		switch(id) {
			case "cch-target-bm":
			case "cch-target":
				var bmLabel = <div><img src={members} />TARGET CROP SELECTION</div>
				break
			case "cch-tracking-bm":
			case "cch-tracking":
				bmLabel = <div><img src={marketing} />AE TRACKING</div>
				break
			default:
				var bmLabel = <div><img src={members} />PROFILE AND MEMBERS</div>
		}
		this.setState({bmLabel: bmLabel})
	}

	render() {
		const view = <div id="cluster-creation-header">
			<div id="burger-menu">
					{/* {id: "cch-tracking-bm", name: "AE TRACKING"} */}
					<PopupMenu list={ [
					{id: "cch-profile-bm", name: "PROFILE AND MEMBERS"},
					{id: "cch-target-bm", name: "TARGET CROP SELECTION"}
				]} onItemSelected={(id, val) => {
					if(this.state.disabled) {
						return
					}
					this.setBurgerMenuLabel(id)
					const idStr = id.split('-')
					this.props.onItemClick(idStr[0] + "-" + idStr[1])
					const items = document.querySelectorAll('#list-menu > div')
					for(const f of items) {
						f.style.background = "#ffffff"
					}
					const elem = document.getElementById(idStr[0] + "-" + idStr[1])
					elem.style.background = "#e2e2e2"
				}}/>
				<div id="burger-menu-label">{this.state.bmLabel}</div>
			</div>
			<div id="list-menu">
				<div id="cch-profile" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={members} />PROFILE AND MEMBERS</div>
				<div id="cch-target" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={members} />FOCUS CROP SELECTION</div>
				{/* <div id="cch-tracking" onClick={this.onItemClick} onMouseEnter={this.mouseEnter}
					onMouseLeave={this.mouseLeave}><img src={marketing} />AE TRACKING</div> */}
			</div>
		</div>
		return(view)
	}
}

class Body extends Component
{
	constructor(props) {
		super(props)
		this.onItemClick = this.onItemClick.bind(this)
	}

	onItemClick(e) {
		console.log(e.target.id)
	}

	render() {
		const view = <div id="cluster-creation-body">
			<div id="ccb-content">
				{this.props.content}
			</div>
			<div id="ccb-content-hl-top"></div>
		</div>
		return(view)
	}
}

export default ClusterCreation
